// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".borderBlue[data-v-791505a8]{\n  border-radius: 4px;\n  border: 1px solid #1A7BEE;\n}\n.borderGreen[data-v-791505a8]{\n  border-radius: 4px;\n  border: 1px solid #0DB952;\n  margin-bottom: 16px !important;\n}\n", ""]);
// Exports
module.exports = exports;
